module.exports = __webpack_public_path__ + "img/icon-template.8a8b4dcc.svg";